import validate from "/home/runner/work/calwe-admin/calwe-admin/node_modules/nuxt/dist/pages/runtime/validate.js";
import check_45auth_45user_45global from "/home/runner/work/calwe-admin/calwe-admin/middleware/checkAuthUser.global.js";
import manifest_45route_45rule from "/home/runner/work/calwe-admin/calwe-admin/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  check_45auth_45user_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}